module.exports = __webpack_public_path__ + "static/media/unnamed-fr.09b87887.png";